import React from 'react';
// import { sortBy } from 'lodash';
import PropTypes from 'prop-types';
import {
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  FormHelperText,
  Checkbox,
  Typography,
  InputAdornment,
  OutlinedInput,
  Grid,
  Card,
  CardContent,
  Skeleton,
  Switch,
  Box,
  CardHeader,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import styles from './styles';

const useStyles = makeStyles(styles);

export const DefaultsFormComponent = (props) => {
  const {
    eventTemplate,
    statusEndId,
    handleChangeDueDateDefaultTime,
    handleChangeDueDateWorkingTime,
    handleChangeDateStatusChangeId,
    isLoading,
  } = props;
  const classes = useStyles();

  const defaultDueDateDays = Math.floor(eventTemplate.dueDateDefaultTime / 8.64e7 || 0);
  const defaultDueDateHours = Math.floor((eventTemplate.dueDateDefaultTime % 8.64e7) / 3.6e6 || 0);
  const defaultDueDateMinutes = Math.floor(Math.round((eventTemplate.dueDateDefaultTime % 3.6e6) / 6e4) || 0);

  const handleDueDateChange = (days = 0, hours = 0, minutes = 0) => {
    const newValue = (86400000 * days) + (3600000 * hours) + (60000 * minutes);
    handleChangeDueDateDefaultTime(newValue < 0
      ? 0
      : newValue, false);
  };

  const handleDueDateWorkingTimeChange = (e) => {
    handleChangeDueDateWorkingTime({
      ...eventTemplate.dueDateWorkingTime,
      [e.target.name]: e.target.checked,
    });
  };

  const label = (
    <Grid item xs={12} md={3} lg={2}>
      <Typography variant="subtitle2">Task Completion Time</Typography>
      <Typography variant="caption" gutterBottom>
        Configure time to complete started tasks.
      </Typography>
    </Grid>
  );

  if (isLoading) {
    return (
      <Grid container spacing={4}>
        {label}
        <Grid item xs={12} lg={10} container className={classes.section}>
          <Card className={classes.card}>
            <CardContent>
              <Skeleton />
              <Skeleton />
              <Skeleton />
            </CardContent>
          </Card>
          <Card className={classes.card}>
            <CardContent>
              <Skeleton />
              <Skeleton />
              <Skeleton />
            </CardContent>
          </Card>
          <Card className={classes.card}>
            <CardContent>
              <Skeleton />
              <Skeleton />
              <Skeleton />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container spacing={4}>
      {label}
      <Grid item xs={12} lg={10} container className={classes.section}>
        <Card className={classes.card}>
          <CardHeader
            title={(
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >Track Task Completion Time <Switch
                checked={!!(eventTemplate.dueDateDefaultTime && eventTemplate.dueDateDefaultTime > 0)}
                onChange={(event) => {
                  if (event.target.checked) {
                    handleDueDateChange(0, 2, 0);
                  } else {
                    handleDueDateChange(0, 0, 0);
                  }
                }}
                inputProps={{ 'aria-label': 'controlled' }}
              />
              </Box>
            )}
            subheader="If turned on, Questri will track and measure the amount of time the task should be completed in from when it is started/created. If a task is not marked complete by a user in the specified time limit, the task moves into a 'Past Due' state."
            sx={{ pb: 0 }}
          />
          <CardContent>
            <Grid container spacing={4}>
              <Grid
                item
                xs={12}
                md={(eventTemplate.dueDateDefaultTime && eventTemplate.dueDateDefaultTime > 0 && !eventTemplate.dueDateDefaultTimeEndOfDay)
                  ? 6
                  : 12}
              >
                <FormGroup>
                  {
                  (eventTemplate.dueDateDefaultTime && eventTemplate.dueDateDefaultTime > 0)
                    ? (
                      <>
                        <FormControlLabel
                          sx={{ mb: 0 }}
                          value={!!eventTemplate.dueDateDefaultTimeEndOfDay}
                          control={<Switch />}
                          checked={!!eventTemplate.dueDateDefaultTimeEndOfDay}
                          onChange={(e) => {
                            if (e.target.checked) {
                              handleChangeDueDateDefaultTime(1, true)
                            } else {
                              handleDueDateChange(0, 12, 0)
                            }
                          }}
                          label="Complete task by end of day"
                        />
                        <FormHelperText>
                          If turned on, the task will enter the &#34;Past Due&#34;
                          state if not completed by the end of the day in which is was created.
                        </FormHelperText>
                        <FormControlLabel
                          sx={{
                            mt: 2,
                            mb: 0,
                          }}
                          control={<Switch />}
                          label="Automatically complete task when task reaches 'Past Due' state"
                          checked={!!eventTemplate.dueDateStatusChangeId}
                          onChange={(event) => {
                            if (event.target.checked) {
                              handleChangeDateStatusChangeId(statusEndId);
                            } else {
                              handleChangeDateStatusChangeId(0);
                            }
                          }}
                        />
                        <FormHelperText>
                          If turned on, Questri will automatically complete the task
                          if the task completion time is exceeded and the task enters the &#34;Past Due&#34;
                          state without being completed by a user.
                        </FormHelperText>
                      </>
                    )
                    : <div />
                }
                </FormGroup>
              </Grid>
              <Grid
                item
                xs={12}
                md={(eventTemplate.dueDateDefaultTime && eventTemplate.dueDateDefaultTime > 0 && !eventTemplate.dueDateDefaultTimeEndOfDay)
                  ? 6
                  : 12}
              >
                {
                (eventTemplate.dueDateDefaultTime && eventTemplate.dueDateDefaultTime > 0 && !eventTemplate.dueDateDefaultTimeEndOfDay)
                  ? (
                    <>
                      <FormControl variant="outlined" className={classes.defaultDueDateTimeInput}>
                        <OutlinedInput
                          label=" "
                          id="default-due-date-days"
                          type="number"
                          margin="dense"
                          value={defaultDueDateDays}
                          onChange={(e) => { handleDueDateChange(e.target.value, defaultDueDateHours, defaultDueDateMinutes); }}
                          endAdornment={<InputAdornment position="end">days</InputAdornment>}
                        />
                      </FormControl>
                      <FormControl variant="outlined" className={classes.defaultDueDateTimeInput}>
                        <OutlinedInput
                          label=" "
                          id="default-due-date-hours"
                          type="number"
                          margin="dense"
                          value={defaultDueDateHours}
                          onChange={(e) => { handleDueDateChange(defaultDueDateDays, e.target.value, defaultDueDateMinutes); }}
                          endAdornment={<InputAdornment position="end">hours</InputAdornment>}
                        />
                      </FormControl>
                      <FormControl variant="outlined" className={classes.defaultDueDateTimeInput}>
                        <OutlinedInput
                          label=" "
                          id="default-due-date-minutes"
                          type="number"
                          margin="dense"
                          value={defaultDueDateMinutes}
                          onChange={(e) => { handleDueDateChange(defaultDueDateDays, defaultDueDateHours, e.target.value); }}
                          endAdornment={<InputAdornment position="end">minutes</InputAdornment>}
                        />
                      </FormControl>
                    </>
                  )
                  : <div />
              }
                {
              (eventTemplate.dueDateDefaultTime && eventTemplate.dueDateDefaultTime > 0 && !eventTemplate.dueDateDefaultTimeEndOfDay)
                ? (
                  <FormControl fullWidth component="fieldset" className={classes.dueDateWorkingTimeFormControl}>
                    <FormLabel>Total time (days, hours, minutes) the task must be completed in before being &#34;Past Due&#34;</FormLabel>
                    <FormGroup row>
                      <FormControlLabel
                        control={<Checkbox checked={!eventTemplate.dueDateWorkingTime || eventTemplate.dueDateWorkingTime.MONDAY !== false} onChange={handleDueDateWorkingTimeChange} name="MONDAY" />}
                        label="Mon"
                      />
                      <FormControlLabel
                        control={<Checkbox checked={!eventTemplate.dueDateWorkingTime || eventTemplate.dueDateWorkingTime.TUESDAY !== false} onChange={handleDueDateWorkingTimeChange} name="TUESDAY" />}
                        label="Tue"
                      />
                      <FormControlLabel
                        control={<Checkbox checked={!eventTemplate.dueDateWorkingTime || !eventTemplate.dueDateWorkingTime.WEDNESDAY !== false} onChange={handleDueDateWorkingTimeChange} name="WEDNESDAY" />}
                        label="Wed"
                      />
                      <FormControlLabel
                        control={<Checkbox checked={!eventTemplate.dueDateWorkingTime || eventTemplate.dueDateWorkingTime.THURSDAY !== false} onChange={handleDueDateWorkingTimeChange} name="THURSDAY" />}
                        label="Thu"
                      />
                      <FormControlLabel
                        control={<Checkbox checked={!eventTemplate.dueDateWorkingTime || eventTemplate.dueDateWorkingTime.FRIDAY !== false} onChange={handleDueDateWorkingTimeChange} name="FRIDAY" />}
                        label="Fri"
                      />
                      <FormControlLabel
                        control={<Checkbox checked={!eventTemplate.dueDateWorkingTime || eventTemplate.dueDateWorkingTime.SATURDAY !== false} onChange={handleDueDateWorkingTimeChange} name="SATURDAY" />}
                        label="Sat"
                      />
                      <FormControlLabel
                        control={<Checkbox checked={!eventTemplate.dueDateWorkingTime || eventTemplate.dueDateWorkingTime.SUNDAY !== false} onChange={handleDueDateWorkingTimeChange} name="SUNDAY" />}
                        label="Sun"
                      />
                    </FormGroup>
                    <FormHelperText>Select or deselect days you do not want included the the time calculation.
                      Helpful when you have non working days.
                    </FormHelperText>
                  </FormControl>
                )
                : <div />
            }
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

DefaultsFormComponent.propTypes = {
  eventTemplate: PropTypes.object,
  statusEndId: PropTypes.number,
  handleChangeDueDateDefaultTime: PropTypes.func,
  handleChangeDueDateWorkingTime: PropTypes.func,
  handleChangeDateStatusChangeId: PropTypes.func,
  isLoading: PropTypes.bool,
};

DefaultsFormComponent.defaultProps = {
  eventTemplate: {},
  statusEndId: -1,
  handleChangeDueDateDefaultTime: () => {},
  handleChangeDueDateWorkingTime: () => {},
  handleChangeDateStatusChangeId: () => {},
  isLoading: true,
};

export default DefaultsFormComponent;
